import type { AdminInsert } from '../../types'
import { supabase } from '../client'

export async function addAdmin(adminInsert: AdminInsert) {
  const { data, error } = await supabase.from('admins').insert(adminInsert).select().single()
  return { data, error }
}
